import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _570baaa6 = () => interopDefault(import('../pages/ai.vue' /* webpackChunkName: "pages/ai" */))
const _3189c6ae = () => interopDefault(import('../pages/ai/index.vue' /* webpackChunkName: "pages/ai/index" */))
const _71587c8a = () => interopDefault(import('../pages/change-password.vue' /* webpackChunkName: "pages/change-password" */))
const _61d736f4 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _1579b3db = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _d2a3d3fa = () => interopDefault(import('../pages/pr/index.vue' /* webpackChunkName: "pages/pr/index" */))
const _cdee00ca = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _7cce9e57 = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _4ba23db4 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _2ad9522d = () => interopDefault(import('../pages/system.vue' /* webpackChunkName: "pages/system" */))
const _7889f33f = () => interopDefault(import('../pages/system/activities.vue' /* webpackChunkName: "pages/system/activities" */))
const _5f0662fc = () => interopDefault(import('../pages/system/activities/index.vue' /* webpackChunkName: "pages/system/activities/index" */))
const _63d4c4d1 = () => interopDefault(import('../pages/system/activities/add.vue' /* webpackChunkName: "pages/system/activities/add" */))
const _0290896a = () => interopDefault(import('../pages/system/activities/_id.vue' /* webpackChunkName: "pages/system/activities/_id" */))
const _6578e762 = () => interopDefault(import('../pages/system/costCenters.vue' /* webpackChunkName: "pages/system/costCenters" */))
const _437948dc = () => interopDefault(import('../pages/system/costCenters/index.vue' /* webpackChunkName: "pages/system/costCenters/index" */))
const _20fb55e1 = () => interopDefault(import('../pages/system/costCenters/add.vue' /* webpackChunkName: "pages/system/costCenters/add" */))
const _8091cb0c = () => interopDefault(import('../pages/system/costCenters/_id.vue' /* webpackChunkName: "pages/system/costCenters/_id" */))
const _655e2c1a = () => interopDefault(import('../pages/system/customers.vue' /* webpackChunkName: "pages/system/customers" */))
const _6794ee36 = () => interopDefault(import('../pages/system/customers/index.vue' /* webpackChunkName: "pages/system/customers/index" */))
const _7a194185 = () => interopDefault(import('../pages/system/customers/add.vue' /* webpackChunkName: "pages/system/customers/add" */))
const _18d5061e = () => interopDefault(import('../pages/system/customers/_id.vue' /* webpackChunkName: "pages/system/customers/_id" */))
const _e9581ab4 = () => interopDefault(import('../pages/system/groups.vue' /* webpackChunkName: "pages/system/groups" */))
const _f3a536ae = () => interopDefault(import('../pages/system/groups/index.vue' /* webpackChunkName: "pages/system/groups/index" */))
const _0d9a8e90 = () => interopDefault(import('../pages/system/groups/add.vue' /* webpackChunkName: "pages/system/groups/add" */))
const _d023055e = () => interopDefault(import('../pages/system/groups/_id.vue' /* webpackChunkName: "pages/system/groups/_id" */))
const _6806d9ed = () => interopDefault(import('../pages/system/holidays.vue' /* webpackChunkName: "pages/system/holidays" */))
const _00b17ab0 = () => interopDefault(import('../pages/system/holidays/index.vue' /* webpackChunkName: "pages/system/holidays/index" */))
const _2ffab702 = () => interopDefault(import('../pages/system/holidays/add.vue' /* webpackChunkName: "pages/system/holidays/add" */))
const _f2832dd0 = () => interopDefault(import('../pages/system/holidays/_id.vue' /* webpackChunkName: "pages/system/holidays/_id" */))
const _287da61e = () => interopDefault(import('../pages/system/integrations.vue' /* webpackChunkName: "pages/system/integrations" */))
const _6c8b0a98 = () => interopDefault(import('../pages/system/integrations/index.vue' /* webpackChunkName: "pages/system/integrations/index" */))
const _6bf88b37 = () => interopDefault(import('../pages/system/orders.vue' /* webpackChunkName: "pages/system/orders" */))
const _05678c7a = () => interopDefault(import('../pages/system/orders/index.vue' /* webpackChunkName: "pages/system/orders/index" */))
const _4dc6a0c9 = () => interopDefault(import('../pages/system/orders/add.vue' /* webpackChunkName: "pages/system/orders/add" */))
const _26fb353c = () => interopDefault(import('../pages/system/orders/_id.vue' /* webpackChunkName: "pages/system/orders/_id" */))
const _b8619810 = () => interopDefault(import('../pages/system/profitCenters.vue' /* webpackChunkName: "pages/system/profitCenters" */))
const _7d32e07b = () => interopDefault(import('../pages/system/profitCenters/index.vue' /* webpackChunkName: "pages/system/profitCenters/index" */))
const _16adfdec = () => interopDefault(import('../pages/system/profitCenters/add.vue' /* webpackChunkName: "pages/system/profitCenters/add" */))
const _d93674ba = () => interopDefault(import('../pages/system/profitCenters/_id.vue' /* webpackChunkName: "pages/system/profitCenters/_id" */))
const _67e70518 = () => interopDefault(import('../pages/system/purchaseOrders.vue' /* webpackChunkName: "pages/system/purchaseOrders" */))
const _2731599b = () => interopDefault(import('../pages/system/purchaseOrders/index.vue' /* webpackChunkName: "pages/system/purchaseOrders/index" */))
const _5833422a = () => interopDefault(import('../pages/system/purchaseOrders/add.vue' /* webpackChunkName: "pages/system/purchaseOrders/add" */))
const _1221f27a = () => interopDefault(import('../pages/system/purchaseOrders/_id.vue' /* webpackChunkName: "pages/system/purchaseOrders/_id" */))
const _3f4e57ac = () => interopDefault(import('../pages/system/tasks.vue' /* webpackChunkName: "pages/system/tasks" */))
const _2d2525a2 = () => interopDefault(import('../pages/system/tasks/index.vue' /* webpackChunkName: "pages/system/tasks/index" */))
const _a071aa84 = () => interopDefault(import('../pages/system/tasks/add.vue' /* webpackChunkName: "pages/system/tasks/add" */))
const _4e82ef57 = () => interopDefault(import('../pages/system/tasks/_id.vue' /* webpackChunkName: "pages/system/tasks/_id" */))
const _48c29d26 = () => interopDefault(import('../pages/system/users.vue' /* webpackChunkName: "pages/system/users" */))
const _4f922f29 = () => interopDefault(import('../pages/system/users/index.vue' /* webpackChunkName: "pages/system/users/index" */))
const _9b6fb990 = () => interopDefault(import('../pages/system/users/add.vue' /* webpackChunkName: "pages/system/users/add" */))
const _5103e7d1 = () => interopDefault(import('../pages/system/users/_id.vue' /* webpackChunkName: "pages/system/users/_id" */))
const _8aa5f85a = () => interopDefault(import('../pages/system/workers.vue' /* webpackChunkName: "pages/system/workers" */))
const _b5a3bfd4 = () => interopDefault(import('../pages/system/workers/index.vue' /* webpackChunkName: "pages/system/workers/index" */))
const _73d52936 = () => interopDefault(import('../pages/system/workers/add.vue' /* webpackChunkName: "pages/system/workers/add" */))
const _64d12ffe = () => interopDefault(import('../pages/system/workers/_id.vue' /* webpackChunkName: "pages/system/workers/_id" */))
const _20c5eb09 = () => interopDefault(import('../pages/cross-company/configuration.vue' /* webpackChunkName: "pages/cross-company/configuration" */))
const _014e46cc = () => interopDefault(import('../pages/cross-company/configuration/index.vue' /* webpackChunkName: "pages/cross-company/configuration/index" */))
const _1a5bc79b = () => interopDefault(import('../pages/cross-company/configuration/add.vue' /* webpackChunkName: "pages/cross-company/configuration/add" */))
const _8dd0e798 = () => interopDefault(import('../pages/cross-company/configuration/_id.vue' /* webpackChunkName: "pages/cross-company/configuration/_id" */))
const _4d8ddcd6 = () => interopDefault(import('../pages/cross-company/mirroring.vue' /* webpackChunkName: "pages/cross-company/mirroring" */))
const _56faead9 = () => interopDefault(import('../pages/cross-company/mirroring/index.vue' /* webpackChunkName: "pages/cross-company/mirroring/index" */))
const _6413d626 = () => interopDefault(import('../pages/economics/revenues.vue' /* webpackChunkName: "pages/economics/revenues" */))
const _2d54a829 = () => interopDefault(import('../pages/economics/revenues/index.vue' /* webpackChunkName: "pages/economics/revenues/index" */))
const _3f564790 = () => interopDefault(import('../pages/economics/revenues/add.vue' /* webpackChunkName: "pages/economics/revenues/add" */))
const _7f10a0d1 = () => interopDefault(import('../pages/economics/revenues/_id.vue' /* webpackChunkName: "pages/economics/revenues/_id" */))
const _3c744515 = () => interopDefault(import('../pages/economics/yearlyAnalisys.vue' /* webpackChunkName: "pages/economics/yearlyAnalisys" */))
const _e3c83050 = () => interopDefault(import('../pages/economics/yearlyAnalisys/index.vue' /* webpackChunkName: "pages/economics/yearlyAnalisys/index" */))
const _ee22a83c = () => interopDefault(import('../pages/refund/refunds.vue' /* webpackChunkName: "pages/refund/refunds" */))
const _2f0f40e5 = () => interopDefault(import('../pages/refund/refunds/index.vue' /* webpackChunkName: "pages/refund/refunds/index" */))
const _67d31818 = () => interopDefault(import('../pages/refund/refunds/add.vue' /* webpackChunkName: "pages/refund/refunds/add" */))
const _6ad2388d = () => interopDefault(import('../pages/refund/refunds/_id.vue' /* webpackChunkName: "pages/refund/refunds/_id" */))
const _54e0afb2 = () => interopDefault(import('../pages/timecard/approval.vue' /* webpackChunkName: "pages/timecard/approval" */))
const _6811356a = () => interopDefault(import('../pages/timecard/approval/index.vue' /* webpackChunkName: "pages/timecard/approval/index" */))
const _1a271bf6 = () => interopDefault(import('../pages/timecard/attendances.vue' /* webpackChunkName: "pages/timecard/attendances" */))
const _5b9f5c0e = () => interopDefault(import('../pages/timecard/attendances/index.vue' /* webpackChunkName: "pages/timecard/attendances/index" */))
const _999f70bc = () => interopDefault(import('../pages/timecard/calendar.vue' /* webpackChunkName: "pages/timecard/calendar" */))
const _11c5e6b6 = () => interopDefault(import('../pages/timecard/calendar/index.vue' /* webpackChunkName: "pages/timecard/calendar/index" */))
const _78ca06e5 = () => interopDefault(import('../pages/timecard/daily.vue' /* webpackChunkName: "pages/timecard/daily" */))
const _046d0da8 = () => interopDefault(import('../pages/timecard/daily/index.vue' /* webpackChunkName: "pages/timecard/daily/index" */))
const _80764e12 = () => interopDefault(import('../pages/timecard/multiple/index.vue' /* webpackChunkName: "pages/timecard/multiple/index" */))
const _cf1a37a2 = () => interopDefault(import('../pages/timecard/occupation.vue' /* webpackChunkName: "pages/timecard/occupation" */))
const _5c6d691c = () => interopDefault(import('../pages/timecard/occupation/index.vue' /* webpackChunkName: "pages/timecard/occupation/index" */))
const _eff5c3f8 = () => interopDefault(import('../pages/timecard/planning/index.vue' /* webpackChunkName: "pages/timecard/planning/index" */))
const _347b6502 = () => interopDefault(import('../pages/timecard/timecards.vue' /* webpackChunkName: "pages/timecard/timecards" */))
const _0196bbf6 = () => interopDefault(import('../pages/timecard/timecards/index.vue' /* webpackChunkName: "pages/timecard/timecards/index" */))
const _02619d14 = () => interopDefault(import('../pages/timecard/timecards/add.vue' /* webpackChunkName: "pages/timecard/timecards/add" */))
const _bdc53ca6 = () => interopDefault(import('../pages/timecard/timecards/_id.vue' /* webpackChunkName: "pages/timecard/timecards/_id" */))
const _4bd210c4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _202614d6 = () => interopDefault(import('../pages/pr/_userId.vue' /* webpackChunkName: "pages/pr/_userId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ai",
    component: _570baaa6,
    children: [{
      path: "",
      component: _3189c6ae,
      name: "ai___it"
    }]
  }, {
    path: "/change-password",
    component: _71587c8a,
    name: "change-password___it"
  }, {
    path: "/dashboard",
    component: _61d736f4,
    name: "dashboard___it"
  }, {
    path: "/login",
    component: _1579b3db,
    name: "login___it"
  }, {
    path: "/pr",
    component: _d2a3d3fa,
    name: "pr___it"
  }, {
    path: "/profile",
    component: _cdee00ca,
    name: "profile___it"
  }, {
    path: "/reset-password",
    component: _7cce9e57,
    name: "reset-password___it"
  }, {
    path: "/search",
    component: _4ba23db4,
    name: "search___it"
  }, {
    path: "/system",
    component: _2ad9522d,
    name: "system___it",
    children: [{
      path: "activities",
      component: _7889f33f,
      children: [{
        path: "",
        component: _5f0662fc,
        name: "system/activities___it"
      }, {
        path: "add",
        component: _63d4c4d1,
        name: "system/activities/add___it"
      }, {
        path: ":id",
        component: _0290896a,
        name: "system/activities/id___it"
      }]
    }, {
      path: "costCenters",
      component: _6578e762,
      children: [{
        path: "",
        component: _437948dc,
        name: "system/costCenters___it"
      }, {
        path: "add",
        component: _20fb55e1,
        name: "system/costCenters/add___it"
      }, {
        path: ":id",
        component: _8091cb0c,
        name: "system/costCenters/id___it"
      }]
    }, {
      path: "customers",
      component: _655e2c1a,
      children: [{
        path: "",
        component: _6794ee36,
        name: "system/customers___it"
      }, {
        path: "add",
        component: _7a194185,
        name: "system/customers/add___it"
      }, {
        path: ":id",
        component: _18d5061e,
        name: "system/customers/id___it"
      }]
    }, {
      path: "groups",
      component: _e9581ab4,
      children: [{
        path: "",
        component: _f3a536ae,
        name: "system/groups___it"
      }, {
        path: "add",
        component: _0d9a8e90,
        name: "system/groups/add___it"
      }, {
        path: ":id",
        component: _d023055e,
        name: "system/groups/id___it"
      }]
    }, {
      path: "holidays",
      component: _6806d9ed,
      children: [{
        path: "",
        component: _00b17ab0,
        name: "system/holidays___it"
      }, {
        path: "add",
        component: _2ffab702,
        name: "system/holidays/add___it"
      }, {
        path: ":id",
        component: _f2832dd0,
        name: "system/holidays/id___it"
      }]
    }, {
      path: "integrations",
      component: _287da61e,
      children: [{
        path: "",
        component: _6c8b0a98,
        name: "system/integrations___it"
      }]
    }, {
      path: "orders",
      component: _6bf88b37,
      children: [{
        path: "",
        component: _05678c7a,
        name: "system/orders___it"
      }, {
        path: "add",
        component: _4dc6a0c9,
        name: "system/orders/add___it"
      }, {
        path: ":id",
        component: _26fb353c,
        name: "system/orders/id___it"
      }]
    }, {
      path: "profitCenters",
      component: _b8619810,
      children: [{
        path: "",
        component: _7d32e07b,
        name: "system/profitCenters___it"
      }, {
        path: "add",
        component: _16adfdec,
        name: "system/profitCenters/add___it"
      }, {
        path: ":id",
        component: _d93674ba,
        name: "system/profitCenters/id___it"
      }]
    }, {
      path: "purchaseOrders",
      component: _67e70518,
      children: [{
        path: "",
        component: _2731599b,
        name: "system/purchaseOrders___it"
      }, {
        path: "add",
        component: _5833422a,
        name: "system/purchaseOrders/add___it"
      }, {
        path: ":id",
        component: _1221f27a,
        name: "system/purchaseOrders/id___it"
      }]
    }, {
      path: "tasks",
      component: _3f4e57ac,
      children: [{
        path: "",
        component: _2d2525a2,
        name: "system/tasks___it"
      }, {
        path: "add",
        component: _a071aa84,
        name: "system/tasks/add___it"
      }, {
        path: ":id",
        component: _4e82ef57,
        name: "system/tasks/id___it"
      }]
    }, {
      path: "users",
      component: _48c29d26,
      children: [{
        path: "",
        component: _4f922f29,
        name: "system/users___it"
      }, {
        path: "add",
        component: _9b6fb990,
        name: "system/users/add___it"
      }, {
        path: ":id",
        component: _5103e7d1,
        name: "system/users/id___it"
      }]
    }, {
      path: "workers",
      component: _8aa5f85a,
      children: [{
        path: "",
        component: _b5a3bfd4,
        name: "system/workers___it"
      }, {
        path: "add",
        component: _73d52936,
        name: "system/workers/add___it"
      }, {
        path: ":id",
        component: _64d12ffe,
        name: "system/workers/id___it"
      }]
    }]
  }, {
    path: "/cross-company/configuration",
    component: _20c5eb09,
    children: [{
      path: "",
      component: _014e46cc,
      name: "cross-company/configuration___it"
    }, {
      path: "add",
      component: _1a5bc79b,
      name: "cross-company/configuration/add___it"
    }, {
      path: ":id",
      component: _8dd0e798,
      name: "cross-company/configuration/id___it"
    }]
  }, {
    path: "/cross-company/mirroring",
    component: _4d8ddcd6,
    children: [{
      path: "",
      component: _56faead9,
      name: "cross-company/mirroring___it"
    }]
  }, {
    path: "/economics/revenues",
    component: _6413d626,
    children: [{
      path: "",
      component: _2d54a829,
      name: "economics/revenues___it"
    }, {
      path: "add",
      component: _3f564790,
      name: "economics/revenues/add___it"
    }, {
      path: ":id",
      component: _7f10a0d1,
      name: "economics/revenues/id___it"
    }]
  }, {
    path: "/economics/yearlyAnalisys",
    component: _3c744515,
    children: [{
      path: "",
      component: _e3c83050,
      name: "economics/yearlyAnalisys___it"
    }]
  }, {
    path: "/refund/refunds",
    component: _ee22a83c,
    children: [{
      path: "",
      component: _2f0f40e5,
      name: "refund/refunds___it"
    }, {
      path: "add",
      component: _67d31818,
      name: "refund/refunds/add___it"
    }, {
      path: ":id",
      component: _6ad2388d,
      name: "refund/refunds/id___it"
    }]
  }, {
    path: "/timecard/approval",
    component: _54e0afb2,
    children: [{
      path: "",
      component: _6811356a,
      name: "timecard/approval___it"
    }]
  }, {
    path: "/timecard/attendances",
    component: _1a271bf6,
    children: [{
      path: "",
      component: _5b9f5c0e,
      name: "timecard/attendances___it"
    }]
  }, {
    path: "/timecard/calendar",
    component: _999f70bc,
    children: [{
      path: "",
      component: _11c5e6b6,
      name: "timecard/calendar___it"
    }]
  }, {
    path: "/timecard/daily",
    component: _78ca06e5,
    children: [{
      path: "",
      component: _046d0da8,
      name: "timecard/daily___it"
    }]
  }, {
    path: "/timecard/multiple",
    component: _80764e12,
    name: "timecard/multiple___it"
  }, {
    path: "/timecard/occupation",
    component: _cf1a37a2,
    children: [{
      path: "",
      component: _5c6d691c,
      name: "timecard/occupation___it"
    }]
  }, {
    path: "/timecard/planning",
    component: _eff5c3f8,
    name: "timecard/planning___it"
  }, {
    path: "/timecard/timecards",
    component: _347b6502,
    children: [{
      path: "",
      component: _0196bbf6,
      name: "timecard/timecards___it"
    }, {
      path: "add",
      component: _02619d14,
      name: "timecard/timecards/add___it"
    }, {
      path: ":id",
      component: _bdc53ca6,
      name: "timecard/timecards/id___it"
    }]
  }, {
    path: "/",
    component: _4bd210c4,
    name: "index___it"
  }, {
    path: "/pr/:userId",
    component: _202614d6,
    name: "pr/userId___it"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
